import { useCallback, useEffect, useRef, useState } from 'react';

const useChimePlayer = (chimeUrl?: string) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleAudioEnded = useCallback(() => {
    setIsPlaying(false);
  }, []);

  const cleanupAudio = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.removeEventListener('ended', handleAudioEnded);
      audioRef.current = null;
    }
  }, [handleAudioEnded]);

  const controller = useCallback(() => {
    if (!chimeUrl) return;
    if (isPlaying) {
      audioRef.current?.pause();
      setIsPlaying(false);
    } else {
      if (!audioRef.current) {
        audioRef.current = new Audio(chimeUrl);
        audioRef.current.loop = false;
        audioRef.current.addEventListener('ended', handleAudioEnded);
      }
      audioRef.current.play().catch((e) => e);
      setIsPlaying(true);
    }
  }, [chimeUrl, isPlaying, handleAudioEnded]);

  useEffect(() => {
    if (audioRef.current) {
      cleanupAudio();
      setIsPlaying(false);
    }

    return () => {
      cleanupAudio();
    };
  }, [chimeUrl, cleanupAudio]);

  return { isPlaying, controller };
};

export default useChimePlayer;
